/* eslint-disable react-hooks/rules-of-hooks */
import {
  createElement, useCallback,
} from 'react';
import { locale } from '@/utils/locale';

import {
  IconSupport, IconExit, IconCoin, IconPerfil, IconData, IconPassword, IconStatus, IconInvoice,
  IconSubscription, IconCreditCard, IconLink, IconWand, IconHome, IconDashboard, IconMail, IconSites,
  IconServer, IconShield, IconStore, IconBookOpen, IconCardRefresh2, IconAiPencil2, IconStarMoving,
  IconRobot,
} from 'gatorcomponents';

import { billingAnalytics } from '@/analytics';
import * as analytics from '@/utils/ThirdParties/tagManager';
import { LOGOUT_URL } from '@/config/whmcsUrls';
import { isBRServer } from '@/utils/Validators/validation';
import { getLinkServerStatus } from '@/utils/Application/links';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import {
  ATIVACAO_ENABLE_ADS_PAGE,
  ENABLE_LOGO_BUILDER,
  ENABLE_STUDIO,
  EXPERIENCE_ACCOUNT_SECURITY,
} from '@/config/GrowthBook/constants';
import { AlertsBell as gatorAlertsBell } from '@/components/Layout/Menu/AlertsBell';
import { logoBuilderActions, preChatActions, productsActions } from '@/redux/modules';
import { useDispatch, useSelector } from 'react-redux';
import { logoBuilderAnalytics } from '@/analytics/logoBuilder';
import { HgProducts } from '@/components/SupportForms/SupportForms.types';
import { useHistory, useLocation } from 'react-router';
import { sessionStorageKeys } from '@/enums/storage/storage.enum';
import useAgentsFactory from '../agentsFactory/useAgentsFactory';

const useMenu = ({
  moreThanOneUser, handleClick, profileIds, MANAGE_USERS_URL,
}) => {
  const shouldRenderCharlieAcademyPass = isBRServer;
  const isBillingSignaturesEnaled = true;
  const isAccountSecurityEnabled = useFeatureIsOn(EXPERIENCE_ACCOUNT_SECURITY);
  const enableLogoBuilder = useFeatureIsOn(ENABLE_LOGO_BUILDER);
  const enableAdsPage = useFeatureIsOn(ATIVACAO_ENABLE_ADS_PAGE);
  const enableStudio = useFeatureIsOn(ENABLE_STUDIO);
  const { subscriptions: subscriptionAnalytics } = billingAnalytics;
  const { available: logoBuilderAvailable, buildingLogo } = useSelector(state => state.logoBuilder);
  const { productsList } = useSelector(state => state.preChat);
  const { features } = useSelector(state => state.summary);

  const location = useLocation();
  const history = useHistory();
  const { openAgentsFactory } = useAgentsFactory();
  const dispatch = useDispatch();
  const setAlertsVisible = (isVisible) => {
    dispatch(productsActions.myAlerts.setVisibility(isVisible));
  };

  const startSupport = () => {
    dispatch(preChatActions.preChat.setShowPreChat());
  };

  const createItem = useCallback(({
    active = false,
    children = [],
    exitApp = false,
    showInDevice = 'mobile',
    icon = null,
    id = '',
    label = 'No Label',
    onClick = () => { },
    open = false,
    show = true,
    tag = '',
    target = '_self',
    to = '',
    tagInText,
    tagShaking = false,
    onlyFillSvg = false,
  }) => ({
    active,
    children,
    exitApp,
    showInDevice,
    icon: icon ? createElement(icon) : null,
    id,
    label,
    onClick,
    open,
    show,
    tag,
    target,
    to,
    tagInText,
    tagShaking,
    onlyFillSvg,
  }), []);

  const studioOptionProps = useCallback(() => {
    const hasStudio = productsList.hostings && !!productsList.hostings.length
      && productsList.hostings.some(product => product && product.status && product.status.toLowerCase() === 'active' && HgProducts.STUDIO_ALL.includes(product.package_id));

    const onClickStudio = () => {
      if (!hasStudio) {
        history.push(locale('routes.home'), { focusOn: 'studio' });
      }
    };

    const currentRouteIsStudio = location.pathname === locale('routes.studio');
    const to = (hasStudio || currentRouteIsStudio) ? locale('routes.studio') : null;

    return {
      icon: IconAiPencil2,
      id: 'drawer-menu-button-studio-page',
      label: locale('menu.studio'),
      to,
      onClick: onClickStudio,
      showInDevice: 'both',
      show: !!(enableStudio && hasStudio),
    };
  }, [history, enableStudio, productsList, location.pathname]);

  const menuArrayV2 = ({ asaas }) => [
    createItem({
      icon: IconHome,
      id: 'drawer-menu-button-home-page',
      label: locale('menu.home'),
      to: locale('routes.home'),
      showInDevice: 'both',
      active: true,
      show: true,
    }),
    createItem({
      icon: IconDashboard,
      id: 'drawer-menu-button-sites-page',
      label: locale('menu.sitesPage'),
      to: locale('routes.sitesPage'),
      showInDevice: 'both',
    }),
    createItem({
      icon: IconMail,
      id: 'drawer-menu-button-emails',
      label: locale('menu.emails'),
      to: locale('routes.emailsList'),
      showInDevice: 'both',
    }),
    createItem({
      icon: IconSites,
      id: 'drawer-menu-button-domains',
      label: locale('menu.domains'),
      to: locale('routes.domains'),
      showInDevice: 'both',
      onlyFillSvg: true,
    }),
    createItem({
      icon: IconServer,
      id: 'drawer-menu-button-products',
      label: locale('menu.v2.products'),
      showInDevice: 'both',
      to: locale('routes.products'),
    }),
    createItem({
      icon: IconShield,
      id: 'drawer-menu-button-security',
      label: locale('menu.security'),
      to: locale('routes.security'),
      show: isBRServer,
      onClick: () => analytics.sitelockMenuButton(),
      showInDevice: 'both',
    }),
    createItem({
      icon: IconRobot,
      id: 'drawer-menu-button-agents',
      label: locale('menu.agents'),
      show: !!features.agent_factory,
      onClick: () => openAgentsFactory('home'),
      showInDevice: 'both',
    }),
    createItem({
      icon: IconStarMoving,
      id: 'drawer-menu-button-marketing',
      label: locale('menu.marketing'),
      to: locale('routes.marketing'),
      showInDevice: 'both',
      tag: locale('tag.new'),
      show: enableAdsPage,
    }),
    createItem({
      icon: IconWand,
      id: 'drawer-menu-button-logo-builder',
      label: locale('menu.logoBuilder'),
      to: logoBuilderAvailable ? locale('routes.logoBuilder') : '/',
      tag: locale('tag.new'),
      showInDevice: 'both',
      show: enableLogoBuilder && (logoBuilderAvailable || buildingLogo) && isBRServer,
      onClick: () => {
        logoBuilderAnalytics.menuClick();
        dispatch(logoBuilderActions.clickedOnMenu());
      },
    }),
    createItem({ ...studioOptionProps() }),
    createItem({
      icon: IconLink,
      id: 'drawer-menu-button-link-na-bio',
      label: locale('menu.linkNaBio'),
      to: locale('routes.linkNaBio'),
      showInDevice: 'both',
    }),
    createItem({
      icon: IconStore,
      id: 'drawer-menu-button-mktplace',
      label: locale('menu.mktPlace'),
      to: locale('routes.mktPlace'),
      show: isBRServer,
      onClick: () => analytics.mktPlaceAcquireButton({
        name: 'Potencialize seu negócio',
        menu: true,
      }),
      showInDevice: 'both',
    }),
    createItem({
      icon: IconBookOpen,
      id: 'drawer-menu-button-courses',
      label: locale('menu.courses'),
      to: locale('routes.courses'),
      show: shouldRenderCharlieAcademyPass,
      showInDevice: 'both',
    }),
    createItem({
      icon: IconCardRefresh2,
      id: 'drawer-menu-button-asaas',
      label: (asaas && asaas.label) ? asaas.label : '',
      to: locale('routes.asaas'),
      show: isBRServer,
      tagInText: asaas.tagInText,
      onClick: () => {
        analytics.menuAsaasClick(asaas.label);
      },
      showInDevice: 'both',
    }),
    createItem({
      label: locale('menu.newBilling'),
      id: 'drawer-menu-button-newBilling',
      icon: IconCoin,
      showInDevice: 'mobile',
      show: isBillingSignaturesEnaled,
      onlyFillSvg: true,
      children: [
        createItem({
          label: locale('menu.billing'),
          icon: IconInvoice,
          id: 'drawer-menu-button-billing',
          to: `${locale('routes.invoices')}${locale('routes.unpaid')}`,
          show: true,
          onlyFillSvg: true,
        }),
        createItem({
          label: locale('menu.subscriptions'),
          icon: IconSubscription,
          id: 'drawer-menu-button-billing-subscriptions',
          to: `${locale('routes.subscriptions')}`,
          onClick: () => subscriptionAnalytics.subscriptionsMenuClick(),
          show: true,
          onlyFillSvg: true,
        }),
        createItem({
          label: locale('menu.creditCard'),
          icon: IconCreditCard,
          id: 'drawer-menu-button-billing-creditCard',
          to: `${locale('routes.creditcard')}`,
          show: true,
          onlyFillSvg: true,
        }),

      ],
    }),
    createItem({
      exitApp: true,
      icon: IconSupport,
      id: 'drawer-menu-button-help',
      label: locale('menu.support'),
      to: locale('routes.help'),
      onClick: () => startSupport(),
      showInDevice: 'mobile',
      onlyFillSvg: true,
    }),
    createItem({
      exitApp: true,
      icon: gatorAlertsBell,
      id: 'drawer-menu-button-notifications',
      label: locale('menu.myAlerts'),
      onClick: () => setAlertsVisible(true),
      show: true,
      showInDevice: 'mobile',
      onlyFillSvg: true,
    }),
    createItem({
      label: `${locale('menu.profile')}`,
      icon: IconPerfil,
      showInDevice: 'mobile',
      show: isBillingSignaturesEnaled,
      onlyFillSvg: true,
      children: [
        createItem({
          label: `${locale('menu.myData')}`,
          icon: IconData,
          id: 'drawer-menu-button-billing',
          to: `${locale('routes.myData')}`,
          show: true,
          onlyFillSvg: true,
        }),
        createItem({
          label: `${locale('menu.changePassword')}`,
          icon: IconPassword,
          id: 'drawer-menu-button-billing-subscriptions',
          to: `${locale('routes.changePassword')}`,
          onClick: () => subscriptionAnalytics.subscriptionsMenuClick(),
          show: !isAccountSecurityEnabled,
          onlyFillSvg: true,
        }),
        createItem({
          label: `${locale('menu.accountSecurity')}`,
          icon: IconPassword,
          id: 'drawer-menu-button-profile-account-security',
          to: `${locale('routes.accountSecurity')}`,
          show: isAccountSecurityEnabled,
          onlyFillSvg: true,
        }),
        createItem({
          label: `${locale('menu.servicesStatus')}`,
          icon: IconStatus,
          id: 'drawer-menu-button-billing-subscriptions',
          to: getLinkServerStatus(),
          onClick: () => subscriptionAnalytics.subscriptionsMenuClick(),
          show: true,
          onlyFillSvg: true,
        }),
        createItem({
          id: `${locale('menu.manageUsers')}`,
          icon: IconPerfil,
          leftIconSize: 'md',
          label: locale('menu.manageUsers'),
          show: moreThanOneUser,
          onlyFillSvg: true,
          onClick: () => handleClick({ id: profileIds.manageUsers, route: MANAGE_USERS_URL, label: `${locale('menu.manageUsers')}` }),
        }),
        createItem({
          exitApp: true,
          icon: IconExit,
          id: 'drawer-menu-button-logout',
          label: locale('menu.quit'),
          to: LOGOUT_URL,
          showInDevice: 'mobile',
          show: true,
          onlyFillSvg: true,
          onClick: () => sessionStorage.removeItem(sessionStorageKeys.chatOpenedBefore),
        }),
      ],
    }),
  ];

  const items = ({ asaasVariation }) => {
    let asaasLabel = '';
    let tagInText = false;
    switch (asaasVariation) {
      case 'variation_B':
        asaasLabel = locale('menu.asaas_b');
        break;
      case 'variation_C':
        asaasLabel = locale('menu.asaas_c');
        tagInText = true;
        break;
      case 'variation_A':
      default:
        asaasLabel = locale('menu.asaas_a');
    }

    return menuArrayV2({
      asaas: { label: asaasLabel, tagInText },
    });
  };

  return {
    createItem,
    items,
  };
};

export default useMenu;
